import React from "react";
import { useAuth } from "../authentication/AuthContext";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { useQuery } from "react-query";

export default function UserAvatar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const {
    data: points,
    error,
    isLoading,
  } = useQuery("user_points", async () => {
    const { data, error } = await supabase
      .from("users")
      .select("points")
      .eq("id", user!.id)
      .single();
    return data;
  });

  return (
    <div className="flex gap-2 sm:gap-4 items-center">
      {isLoading && <div className="loading loading-sm"></div>}
      {!isLoading && (
        <span className="text-inherit text-lg font-bold">
          {points?.points ?? 0}
        </span>
      )}
      {/*  <span className="text-inherit max-md:hidden">{user!.email}</span> */}
      <div
        className="avatar placeholder cursor-pointer hover:scale-105"
        onClick={() => navigate(`/users/edit/${user!.id}`)}
      >
        <div className="bg-neutral text-neutral-content rounded-full w-8 md:w-10">
          <span>{user!.email?.substring(0, 2).toUpperCase()}</span>
        </div>
      </div>{" "}
    </div>
  );
}
